import usePolledQuery from "apollo/usePolledQuery";
import { PollingIntervalGroups } from "apollo/constants";

import { GET_TIME_TO_RECOVERY_RANGE } from "./gql";

type UseGetTimeToRecoveryRangeProps = {
  startTimeUnix: number;
  endTimeUnix: number;
};

const useGetTimeToRecoveryRange = ({
  startTimeUnix,
  endTimeUnix,
}: UseGetTimeToRecoveryRangeProps) => {
  const { data, loading, error, refetch, networkStatus, previousData } = usePolledQuery(
    GET_TIME_TO_RECOVERY_RANGE,
    {
      variables: {
        input: {
          startTime: startTimeUnix,
          endTime: endTimeUnix,
          timezone: null,
        },
      },
      pollingGroup: PollingIntervalGroups.Dashboard,
    }
  );

  // Returns raw backend DataPoints (timestamp unix and value in seconds)
  const range =
    data?.metricsRange?.averageTimeToRecoveryRange ??
    previousData?.metricsRange?.averageTimeToRecoveryRange;

  return {
    range,
    hasRuns: !!data?.metricsRange?.hasRuns,
    loading,
    error,
    refetch,
    networkStatus,
  };
};

export default useGetTimeToRecoveryRange;
